export const services = {
  seo: {
    title: 'Services | LensBank Professional Equipment Rental',
    description: 'Professional equipment rental, Taiwan-Japan co-production, Japan post-production, and Urent consignment rental services. One-stop solution for all your visual production needs.',
    keywords: 'equipment rental,Taiwan-Japan production,color grading,consignment rental,film production'
  },
  hero: {
    title: 'Our Services',
    subtitle: 'One-stop visual production solutions'
  },
  equipment: {
    title: 'Professional Equipment Rental',
    subtitle: 'Over 1,000+ professional cinema and photography items',
    desc: 'Full-range professional equipment rental including cameras, lenses, lighting, audio, monitors, and stabilizers. All items are regularly serviced to ensure optimal performance.',
    features: [
      'Multi-brand selection: Canon, Sony, RED, ARRI, and more',
      'Flexible rental periods: daily, weekly, monthly',
      'Expert consultation: help selecting the right gear',
      'Technical support: usage guidance and troubleshooting',
      'Insurance options: comprehensive equipment coverage (Japan only)'
    ]
  },
  japanRental: {
    sectionLabel: 'Japan Equipment Rental',
    title: 'Japan Equipment Rental Service',
    content: 'As a trusted partner, LensBank is pleased to introduce CRANK, the equipment rental division of TREE Digital Studio Inc., based in Tokyo, Japan.\n\nTREE Digital Studio Inc. has Mandarin-speaking staff available to assist Taiwanese production teams with seamless communication. You can also contact TREE Digital Studio Inc. (CRANK) directly. We respect each client\'s needs and flexibility is always an option.',
    learnMore: 'Learn More',
    priceNote: 'Japan equipment rental pricing is based on official Japanese quotes. LensBank provides supporting services from the Taiwan side.'
  },
  portfolio: {
    title: 'Equipment Support',
    subtitle: 'Selected Works',
    desc: 'Our equipment has been used on many outstanding productions. Below is a selection of notable collaborations.',
    viewAll: 'View More'
  },
  crew: {
    subtitle: 'Professional Crew',
    title: 'Crew Dispatch Highlights',
    desc: 'Our professional crew provides on-set services for all project types, from commercial shoots to documentary productions',
    viewAll: 'View More Works'
  },
  taiwanJapan: {
    hero: {
      title: 'Taiwan–Japan Production Services',
      description: 'Cross-border production support between Taiwan and Japan, including equipment rental, film crew, location coordination, and administrative assistance — a complete one-stop solution.'
    },
    features: {
      title: 'Service Features',
      equipment: {
        title: 'Cross-border Equipment',
        description: 'Professional equipment rental and cross-border logistics in both Taiwan and Japan, ensuring gear arrives on time.'
      },
      team: {
        title: 'Local Film Crew',
        description: 'Experienced local crew familiar with regional shooting environments and cultural context.'
      },
      logistics: {
        title: 'Location & Admin Support',
        description: 'Assistance with location scouting, filming permits, and administrative processes.'
      },
      support: {
        title: 'Full Production Support',
        description: 'Translation, communication coordination, and logistics support for a smooth production.'
      }
    },
    process: {
      title: 'Our Process',
      step1: {
        title: 'Consultation',
        description: 'We learn about your production needs, budget, and schedule.'
      },
      step2: {
        title: 'Planning',
        description: 'We provide a complete production plan including equipment, crew, and location recommendations.'
      },
      step3: {
        title: 'Preparation',
        description: 'We coordinate all resources and handle administrative processes to ensure everything is ready.'
      },
      step4: {
        title: 'On-set Support',
        description: 'Full on-set support to ensure the production runs smoothly.'
      }
    },
    form: {
      title: 'Book a Consultation',
      description: 'Fill in the form below and we\'ll get back to you as soon as possible',
      location: {
        label: 'Shooting Location',
        placeholder: 'Select shooting location',
        taiwan: 'Taiwan',
        japan: 'Japan',
        other: 'Other'
      },
      city: {
        label: 'City',
        placeholder: 'Enter city name'
      },
      dateRange: {
        start: 'Expected Start Date',
        end: 'Expected End Date'
      },
      needTypes: {
        label: 'Services Needed',
        equipment: 'Equipment Rental',
        photographer: 'Cinematographer',
        lighting: 'Gaffer',
        sound: 'Sound Recordist',
        dit: 'DIT',
        other: 'Other'
      },
      budget: {
        label: 'Budget Range',
        placeholder: 'Select budget range',
        range1: 'Under NT$50,000',
        range2: 'NT$50,000 – 100,000',
        range3: 'NT$100,000 – 300,000',
        range4: 'NT$300,000 – 500,000',
        range5: 'Over NT$500,000',
        negotiable: 'Negotiable'
      },
      company: {
        label: 'Company Name',
        placeholder: 'Enter company name (optional)'
      },
      name: {
        label: 'Contact Name',
        placeholder: 'Enter your name'
      },
      email: {
        label: 'Email',
        placeholder: 'Enter your email address'
      },
      phone: {
        label: 'Phone',
        placeholder: 'Enter your phone number'
      },
      projectDescription: {
        label: 'Project Description',
        placeholder: 'Briefly describe your project, requirements, and any special requests...'
      },
      attachments: {
        label: 'Attachments',
        description: 'You may upload scripts, storyboards, or reference materials (optional)'
      },
      submit: 'Send Inquiry',
      submitting: 'Sending...',
      success: 'Thank you for your inquiry! We\'ll be in touch shortly.',
      error: 'Submission failed. Please try again or contact us directly.'
    }
  },
  postProduction: {
    hero: {
      title: 'Japan Post-Production Services',
      description: 'Collaborating with Japan\'s top post-production studios to deliver professional editing, color grading, VFX, and sound design. Ideal for high-end commercials, brand films, and feature productions.'
    },
    viewWorks: 'View Reference Works',
    features: {
      title: 'Why Choose Us',
      quality: {
        title: 'Premium Quality',
        description: 'Japanese commercial-grade post-production standards, with meticulous attention to every detail.'
      },
      experience: {
        title: 'Extensive Experience',
        description: 'The team brings rich experience across commercials, films, and music videos of all styles.'
      },
      equipment: {
        title: 'Pro-grade Tools',
        description: 'Industry-standard software and hardware including DaVinci Resolve, Avid, and Pro Tools.'
      },
      communication: {
        title: 'Bilingual Communication',
        description: 'Mandarin-Japanese bilingual service ensuring accurate requirement transfer and seamless collaboration.'
      }
    },
    services: {
      title: 'Service Items',
      editing: {
        title: 'Professional Editing',
        items: [
          'Commercial editing',
          'Brand identity films',
          'Documentary editing',
          'Music videos',
          'Corporate promos'
        ]
      },
      grading: {
        title: 'Color Grading',
        items: [
          'DaVinci Resolve grading',
          'Cinema-grade color management',
          'Stylized grading',
          'HDR grading',
          'Custom LUT creation'
        ]
      },
      vfx: {
        title: 'Visual Effects',
        items: [
          'Compositing',
          'Motion graphics',
          'Chroma key / green screen',
          'Scene extension',
          'VFX repair'
        ]
      },
      sound: {
        title: 'Sound Post-production',
        items: [
          'Sound design',
          'Voiceover recording',
          'Music mixing',
          'Ambience processing',
          'Dolby Atmos'
        ]
      }
    },
    process: {
      title: 'Production Process',
      step1: {
        title: 'Briefing',
        description: 'We understand your project requirements, style direction, budget, and timeline, then provide recommendations and a quote.'
      },
      step2: {
        title: 'Material Handoff',
        description: 'Original footage is transferred via cloud. We confirm file format, color space, and technical specs.'
      },
      step3: {
        title: 'Production & Review',
        description: 'We complete editing, grading, and VFX. You review online and provide real-time feedback.'
      },
      step4: {
        title: 'Final Delivery',
        description: 'Final deliverables in multiple formats, with project archiving service included.'
      }
    },
    form: {
      title: 'Book a Consultation',
      description: 'Fill in the form below and we\'ll get back to you as soon as possible',
      serviceType: {
        label: 'Service Required',
        editing: 'Editing',
        grading: 'Color Grading',
        vfx: 'Visual Effects',
        sound: 'Sound Post-production',
        package: 'Integrated Package'
      },
      projectType: {
        label: 'Project Type',
        placeholder: 'Select project type',
        commercial: 'Commercial',
        brand: 'Brand Film',
        mv: 'Music Video',
        documentary: 'Documentary',
        film: 'Film / Short Film',
        other: 'Other'
      },
      duration: {
        label: 'Video Length (seconds)',
        placeholder: 'e.g. 30'
      },
      deadline: {
        label: 'Expected Completion Date'
      },
      budget: {
        label: 'Budget Range',
        placeholder: 'Select budget range',
        range1: 'Under NT$30,000',
        range2: 'NT$30,000 – 80,000',
        range3: 'NT$80,000 – 150,000',
        range4: 'NT$150,000 – 300,000',
        range5: 'Over NT$300,000',
        negotiable: 'Negotiable'
      },
      company: {
        label: 'Company Name',
        placeholder: 'Enter company name (optional)'
      },
      name: {
        label: 'Contact Name',
        placeholder: 'Enter your name'
      },
      email: {
        label: 'Email',
        placeholder: 'Enter your email address'
      },
      phone: {
        label: 'Phone',
        placeholder: 'Enter your phone number'
      },
      reference: {
        label: 'Reference Video Link',
        placeholder: 'YouTube, Vimeo, etc. (optional)'
      },
      projectDescription: {
        label: 'Project Description',
        placeholder: 'Briefly describe your project, style preferences, and special requirements...'
      },
      submit: 'Send Inquiry',
      submitting: 'Sending...',
      success: 'Thank you for your inquiry! We\'ll be in touch shortly.',
      error: 'Submission failed. Please try again or contact us directly.'
    }
  },
  urent: {
    hero: {
      title: 'Urent Consignment Rental',
      description: 'Consign your idle camera equipment to LensBank. We handle storage, maintenance, and rental management — you simply earn passive income.'
    },
    features: {
      title: 'Service Features',
      income: {
        title: 'Passive Income',
        description: 'Your equipment earns revenue even when you\'re not using it — a continuous return on investment.'
      },
      management: {
        title: 'Professional Care',
        description: 'Climate-controlled storage environment with regular professional maintenance to keep equipment in peak condition.'
      },
      insurance: {
        title: 'Insurance Coverage',
        description: 'Comprehensive equipment insurance — any damage during a rental is covered by the platform.'
      },
      transparent: {
        title: 'Transparent Revenue Split',
        description: 'Clear revenue-sharing structure with monthly settlement and payout.'
      }
    },
    howItWorks: {
      title: 'How It Works',
      step1: {
        title: 'Submit Application',
        description: 'Fill in equipment details, upload photos, and provide proof of purchase and accessories list.'
      },
      step2: {
        title: 'Evaluation',
        description: 'We assess the equipment condition, market demand, and rental value.'
      },
      step3: {
        title: 'Sign Agreement',
        description: 'Confirm the revenue split, storage terms, and insurance coverage.'
      },
      step4: {
        title: 'Start Earning',
        description: 'Your equipment goes live for rental and starts generating passive income.'
      }
    },
    revenue: {
      title: 'Revenue Split',
      description: 'A fully transparent revenue-sharing model that maximizes the value of your equipment',
      owner: 'Equipment Owner',
      platform: 'Platform Management Fee',
      note: '* Actual split ratio is adjusted based on equipment type and market demand'
    },
    requirements: {
      title: 'Eligibility Requirements',
      item1: 'Equipment must be in fully functional condition with no major defects or failures',
      item2: 'All accessories must be included (batteries, charger, original packaging, etc.)',
      item3: 'Proof of purchase or invoice required to verify legal ownership',
      item4: 'Market value of equipment must be at least NT$30,000',
      item5: 'Agreement to sign the consignment contract and insurance terms'
    },
    form: {
      title: 'Apply Now',
      description: 'Fill in the form below and we\'ll get back to you as soon as possible',
      equipmentName: {
        label: 'Equipment Name',
        placeholder: 'e.g. Canon EOS R5, Sony FX3'
      },
      category: {
        label: 'Equipment Category',
        placeholder: 'Select a category',
        camera: 'Camera',
        lens: 'Lens',
        lighting: 'Lighting',
        sound: 'Audio',
        monitor: 'Monitor',
        stabilizer: 'Stabilizer',
        other: 'Other'
      },
      brand: {
        label: 'Brand',
        placeholder: 'e.g. Canon, Sony, RED'
      },
      purchaseDate: {
        label: 'Purchase Date'
      },
      condition: {
        label: 'Condition',
        new: 'Brand new',
        excellent: 'Excellent (90%+ like new)',
        good: 'Good (70–80% like new)',
        fair: 'Fair (50–60% like new)'
      },
      accessories: {
        label: 'Accessories List',
        placeholder: 'List all accessories, e.g. OEM battery x2, charger, original packaging, manual...'
      },
      rentalPeriod: {
        label: 'Preferred Consignment Period',
        placeholder: 'Select a period',
        threeMonths: '3 months',
        sixMonths: '6 months',
        oneYear: '1 year',
        twoYears: '2 years',
        threeYears: '3 years'
      },
      photos: {
        label: 'Equipment Photos',
        description: 'Upload clear photos from front, side, back, and of accessories (minimum 3 photos)'
      },
      name: {
        label: 'Contact Name',
        placeholder: 'Enter your name'
      },
      email: {
        label: 'Email',
        placeholder: 'Enter your email address'
      },
      phone: {
        label: 'Phone',
        placeholder: 'Enter your phone number'
      },
      notes: {
        label: 'Additional Notes',
        placeholder: 'Any other information you would like to share...'
      },
      agreement: {
        label: 'I have read and agree to the',
        terms: 'Consignment Service Terms'
      },
      disclaimer: 'We reserve the right of final review.',
      submit: 'Submit Application',
      submitting: 'Submitting...',
      success: 'Thank you for your application! We\'ll be in touch shortly.',
      error: 'Submission failed. Please try again or contact us directly.'
    },
    title: 'Urent Consignment Rental',
    subtitle: 'Turn idle equipment into income',
    desc: 'Consign your idle camera equipment to LensBank. We handle storage, maintenance, and rental management — you simply earn passive income.',
    highlights: [
      'Professional storage: climate-controlled environment',
      'Regular maintenance: inspected by our expert team',
      'Insurance coverage: comprehensive equipment insurance',
      'Transparent revenue split: clear earning mechanism',
      'Flexible retrieval: reclaim your equipment anytime'
    ],
    process: {
      title: 'Consignment Process',
      steps: [
        {
          title: 'Submit Application',
          desc: 'Fill in equipment details and photos'
        },
        {
          title: 'Evaluation',
          desc: 'Condition and market demand assessment'
        },
        {
          title: 'Sign Agreement',
          desc: 'Confirm revenue split and terms'
        },
        {
          title: 'Start Earning',
          desc: 'Equipment goes live and starts generating income'
        }
      ]
    }
  },
  cta: {
    title: 'Ready to Start Your Project?',
    subtitle: 'Contact us today and let our expert team help bring your vision to life',
    button: 'Get in Touch'
  }
};
